import { OrderingInitialState, SetAddCustomerModalAction } from '@reducers/ordering/types';

export const setAddCustomerModal = (
  state: OrderingInitialState,
  action: SetAddCustomerModalAction
): OrderingInitialState => ({
  ...state,
  customerState: {
    ...state.customerState,
    displayAddCustomerModal: action.payload,
  },
});
